import { Text } from '@doordash/design-language';
import * as React from 'react';
import { shouldShowPageNumber } from './Pagination';
import { PageNumber, PageEllipsisWrapper } from './styles';

var Page = function Page(_ref) {
  var page = _ref.page,
      currentPage = _ref.currentPage,
      numPages = _ref.numPages,
      pagesAroundCurrent = _ref.pagesAroundCurrent,
      pagesBeforeTruncate = _ref.pagesBeforeTruncate,
      changePage = _ref.changePage,
      currentPageLabel = _ref.currentPageLabel,
      goToPageLabel = _ref.goToPageLabel;

  if (shouldShowPageNumber(page, currentPage, numPages, pagesAroundCurrent, pagesBeforeTruncate)) {
    var isCurrent = page === currentPage;
    return /*#__PURE__*/React.createElement(PageNumber, {
      "aria-label": isCurrent ? currentPageLabel : goToPageLabel,
      key: page,
      isCurrent: isCurrent,
      onClick: function onClick() {
        return changePage(page);
      }
    }, /*#__PURE__*/React.createElement(Text, {
      color: Text.Colors[isCurrent ? 'PaginationNumberedSelectedForeground' : 'PaginationNumberedUnselectedForeground'],
      styles: Text.Styles.PaginationNumberedAction
    }, page.toLocaleString()));
  }

  return /*#__PURE__*/React.createElement(PageEllipsisWrapper, null, /*#__PURE__*/React.createElement(Text, {
    color: Text.Colors.TextTertiary,
    key: page,
    styles: Text.Styles.PaginationNumberedAction
  }, "..."));
};

export default Page;